import { useState } from 'react';
import { TableInput } from '../../../../components/common';

interface Ifoot {
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ moduleData, isView }: Ifoot) => {
  const [render, setRender] = useState(false);

  return (
    <tfoot>
      {/* <tr>
        <th colSpan={4}>{moduleData?.report_prepared_by}</th>
        <th colSpan={6}>{moduleData?.report_approved_by}</th>
        <th colSpan={4}>
          <TableInput
            name="approved_by_if_partially_approved"
            type="text"
            value={moduleData.approved_by_if_partially_approved}
            onChange={(e) => {
              moduleData.approved_by_if_partially_approved = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr> */}
      {/* <tr>
        <th colSpan={4}>CHECKED BY</th>
        <th colSpan={6}>VERIFIED BY</th>
        <th colSpan={4}>
          APPROVED BY ( DPM Sign Required only if conditionally accepted )
        </th>
      </tr>
      <tr>
        <th colSpan={14} align="left">
          VENDOR:- {moduleData.vendor_name}
        </th>
      </tr> */}
      {/* <tr>
        <th colSpan={14} align="left">
          Legend for Judgment (To be filled by SKH) <br />O : Result OK X :
          Result NG Δ : If Conditionally Accepted
        </th>
      </tr>
      <tr>
        <th colSpan={14} align="left">
          ICPL-QA-F-001-00
        </th>
      </tr> */}
      <tr>
        <th colSpan={14} rowSpan={2}>
          NOTE:- TO BE MENTION FOR APPROVAL AT THE TIME OF EACH SET UP. ALL
          <br></br>
          DIMENSION ARE IN MM WHERE IT IS CHANGED HAS BEEN MENTIONED.
        </th>
        <th colSpan={7 + 2} rowSpan={2}>
          VERIFIED BY (SIGN):- {moduleData?.report_approved_by}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
